import React, { Component, Fragment } from "react";
import { useEffect } from "react";
import { useState } from "react";
import { NavLink } from "react-router-dom";
const Navbar = (props) => {
  const [toogleMenu, setToogleMenu] = useState(false)

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({
        behavior: 'smooth',
        block: 'start',
      });
    }
    setToogleMenu(false); // Close mobile menu after click
  };

  return (
    <Fragment>
      <div className={"wrapper__side-nav-mobile d-flex d-lg-none " + (toogleMenu ? "active" : "")}>
        <div className="d-flex flex-wrap w-100">
          <div className="w-100">
            <div className="d-flex align-items-center justify-content-between mb-4">
              <NavLink
                to="/"
                exact
                class="navbar-brand font__size--24 text__24-1024 semi-bold color__black"
              >
                <img src="./../images/logo.svg" alt="" className='mw-50' />
              </NavLink>
              <img src="./../images/clsoe2.png" onClick={() => setToogleMenu(!toogleMenu)} className="pointer" alt="" />
            </div>
            <div className="menu">
              <a href="#home" onClick={(e) => { e.preventDefault(); scrollToSection('home'); }} className="medium font__size--14 text__14-1024 color__black">Home</a>
              <hr />
              <a href="#about" onClick={(e) => { e.preventDefault(); scrollToSection('about'); }} className="medium font__size--14 text__14-1024 color__black">Über uns</a>
              <hr />
              <a href="#services" onClick={(e) => { e.preventDefault(); scrollToSection('services'); }} className="medium font__size--14 text__14-1024 color__black">Services</a>
              <hr />
              <a href="#gallery" onClick={(e) => { e.preventDefault(); scrollToSection('gallery'); }} className="medium font__size--14 text__14-1024 color__black">Galerie</a>
              <hr />
              <a href="#blog" onClick={(e) => { e.preventDefault(); scrollToSection('blog'); }} className="medium font__size--14 text__14-1024 color__black">Unser Angebot</a>
              <hr />
            </div>
          </div>
        </div>
      </div >
      <div className="bg__wrap-menu d-lg-none" onClick={() => setToogleMenu(!toogleMenu)}></div>
      <nav
        className="navbar navbar-expand-lg bg__black-2 wrapper__navbar position-relative z-2"
        data-aos="fade-down"
        data-aos-duration="1000"
        data-aos-delay="300"
      >
        <div className="container position-relative">
          <NavLink
            to="/"
            exact
            class="navbar-brand font__size--24 text__24-1024 semi-bold color__black"
          >
            <img src="./../images/logo.svg" alt="" className='mw-50' style={{ maxWidth: '130px' }} />
          </NavLink>

          <div
            className="collapse navbar-collapse wrapper__navbar-menu ml-lg-5"
            id="navbarSupportedContent"
          >
            <ul className="navbar-nav menu__center">
              <li className="nav-item">
                <a
                  href="#home"
                  onClick={(e) => { e.preventDefault(); scrollToSection('home'); }}
                  class="nav-link semi-bold font__size--14 text__14-1024 color__black text-capitalize hover"
                >
                  Home
                </a>
              </li>
              <li className="nav-item">
                <a
                  href="#about"
                  onClick={(e) => { e.preventDefault(); scrollToSection('about'); }}
                  class="nav-link semi-bold font__size--14 text__14-1024 color__black text-capitalize hover"
                >
                  Über uns
                </a>
              </li>
              <li className="nav-item">
                <a
                  href="#services"
                  onClick={(e) => { e.preventDefault(); scrollToSection('services'); }}
                  class="nav-link semi-bold font__size--14 text__14-1024 color__black text-capitalize hover"
                >
                  Services
                </a>
              </li>
              <li className="nav-item">
                <a
                  href="#gallery"
                  onClick={(e) => { e.preventDefault(); scrollToSection('gallery'); }}
                  class="nav-link semi-bold font__size--14 text__14-1024 color__black text-capitalize hover"
                >
                  Galerie
                </a>
              </li>
              <li className="nav-item">
                <a
                  href="#blog"
                  onClick={(e) => { e.preventDefault(); scrollToSection('blog'); }}
                  class="nav-link semi-bold font__size--14 text__14-1024 color__black text-capitalize hover"
                >
                  Unser Angebot
                </a>
              </li>
            </ul>
          </div>

          <div
            onClick={() => setToogleMenu(!toogleMenu)}
            class="nav__button d-lg-none position-relative ml-auto flex-shrink-0"
          >
            <span></span>
            <span></span>
            <span></span>
          </div>
          <a href="#contact" onClick={(e) => { e.preventDefault(); scrollToSection('contact'); }} className="d-none d-lg-block medium font__size--14 text__14-1024 btn btn__green color__white shadow ml-auto rounded__50 pointer">Kontakt</a>
        </div>
      </nav>
    </Fragment >
  );
};

export default Navbar;
